import * as React from 'react';
import { Button, Table } from 'antd';
import { Items } from 'components/MarketingCampaign/MarketingCampaignTable';
import { LanguageContext } from 'contexts/LanguageContext';
import { Modal } from 'components/MarketingCampaign/styles';

const getStatusTagStyle = (status: string) => {
	switch (status) {
		case 'READ':
		case 'DELIVERED':
			return { background: '#389e0d', color: '#fff' };
		case 'SENT':
			return { background: '#096dd9', color: '#fff' };
		case 'PENDING':
			return { background: '#d4b106', color: '#fff' };
		case 'FAILED':
		case 'ERROR':
			return { background: '#cf1322', color: '#fff' };
		default:
			return { background: '#595959', color: '#fff' };
	}
};

const StatusTag = ({ status, dictionary }: { status: string; dictionary: any }) => {
	const textMap: Record<string, string> = {
		READ: dictionary.read,
		DELIVERED: dictionary.delivered,
		SENT: dictionary.sent,
		FAILED: dictionary.failed,
		ERROR: dictionary.error,
		PENDING: dictionary.status_pending,
	};

	const style = getStatusTagStyle(status);

	return (
		<span
			style={{
				padding: '4px 10px',
				borderRadius: '6px',
				fontWeight: 600,
				fontSize: '12px',
				display: 'inline-block',
				...style,
			}}
		>
			{textMap[status] || status}
		</span>
	);
};

interface CampaignItemsModalProps {
	open: boolean;
	onClose: () => void;
	campaign: Items | undefined;
}

const CampaignItemsModal: React.FC<CampaignItemsModalProps> = ({ open, onClose, campaign }) => {
	const { dictionary } = React.useContext(LanguageContext);

	const columns = [
		{
			title: dictionary.destination_number,
			dataIndex: 'number',
			key: 'destination_number',
		},
		{
			title: dictionary.message_status,
			dataIndex: 'messageStatus',
			key: 'status',
			render: (value: string) => <StatusTag status={value} dictionary={dictionary} />,
		},
		{
			title: dictionary.description_status,
			dataIndex: 'statusDescription',
			key: 'description',
			render: (_: any, record: any) => {
				const successStatuses = ['READ', 'DELIVERED'];

				if (successStatuses.includes(record.messageStatus) && !record.statusDescription) {
					return dictionary.message_success;
				}

				return record.statusDescription || '-';
			},
		},
	];

	return (
		<Modal
			width={900}
			title={campaign?.title}
			visible={open}
			footer={[
				<Button key="ok" type="primary" onClick={onClose}>
					OK
				</Button>,
			]}
			closeIcon={onClose}
		>
			<Table
				dataSource={campaign?.audiences || []}
				rowKey="id"
				columns={columns}
				pagination={{
					pageSize: 10,
				}}
			/>
		</Modal>
	);
};

export default CampaignItemsModal;
